import React, { useState, useMemo, useEffect } from 'react'

import ReactHtmlParser from 'react-html-parser';

import useVisibility from '../../../../../../utils/isVisible';
import DraggableBox from '../../../../../../utils/draggableBox';

import { renderDefault, renderSocialChannel } from './KwikMessageRenderer'

const MemoMessage = ({ message, messages, index, accountcode, isManageCalls, queuesName, enterpriseId, activeChat, visibleHook, parent, parentState, setReplying, updateMessage, supervisedQueues = [] }) => {

    const [isVisible, currentElement, calcVisibility] = useVisibility(0, 100, parent)
    const [buttonDisabled, setButtonDisabled] = useState(false)
    const [showHtmlContent, setShowHtmlContent] = useState(null)

    useEffect(() => {
        if (isVisible && visibleHook)
            visibleHook(message, currentElement)
        calcVisibility()
    }, [isVisible])


    const [refresh, setRefresh] = useState(false)

    const reloadState = () => { setRefresh(p => !p) }

    const messageComp = useMemo(() => {
        if (!('message' in message))
            message.message = message.msg

        // Ignore start viewer message
        if (message.message.indexOf('<<< STARTING VIEWER >>>') !== -1)
            return

        if (activeChat && 'platform' in activeChat && activeChat.platform === 'EMAIL')
            return renderSocialChannel(message, index, accountcode, isManageCalls, queuesName, enterpriseId, activeChat, reloadState, buttonDisabled, setButtonDisabled, parentState, setReplying, setShowHtmlContent)
        else
            return renderDefault(message, messages, index, accountcode, isManageCalls, queuesName, enterpriseId, activeChat, reloadState, buttonDisabled, setButtonDisabled, parentState, setReplying, updateMessage, supervisedQueues)
    }, [message.id, message.status, message.transcription, message.transcription_status, refresh, isVisible, message.iso_time, message.time, message.is_client_read, message.reaction, showHtmlContent, messages?.length])

    return (
        <span ref={currentElement}>
            {messageComp}
            {showHtmlContent && (
                <DraggableBox 
                    show={!!showHtmlContent} 
                    handleClose={() => setShowHtmlContent(null)} 
                    x={window.innerWidth / 2 - 250}
                    y={-window.innerHeight / 2 + 250} 
                    className='draggable-box-email'
                    title='Visualização do E-mail'
                >
                    {ReactHtmlParser(showHtmlContent)}
                </DraggableBox>
            )}
        </span>
    )
}

function areEqual({ message: prevMessage }, { message }) {
    return message === prevMessage;
}


export default MemoMessage
